import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  unit = '', 
  change, 
  changeType = 'neutral', 
  icon, 
  threshold = null,
  trendData = [],
  status = 'normal'
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'critical': return 'border-error bg-error/5';
      case 'warning': return 'border-warning bg-warning/5';
      case 'good': return 'border-success bg-success/5';
      default: return 'border-border bg-card';
    }
  };

  const getChangeColor = () => {
    switch (changeType) {
      case 'positive': return 'text-success';
      case 'negative': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getChangeIcon = () => {
    switch (changeType) {
      case 'positive': return 'TrendingUp';
      case 'negative': return 'TrendingDown';
      default: return 'Minus';
    }
  };

  return (
    <div className={`rounded-lg border p-4 transition-hover hover:elevation-1 ${getStatusColor()}`}>
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name={icon} size={20} className="text-muted-foreground" />
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {status !== 'normal' && (
          <div className={`w-2 h-2 rounded-full ${
            status === 'critical' ? 'bg-error' : 
            status === 'warning' ? 'bg-warning' : 'bg-success'
          } pulse-status`}></div>
        )}
      </div>
      {/* Value */}
      <div className="mb-3">
        <div className="flex items-baseline space-x-1">
          <span className="text-2xl font-semibold text-foreground">{value}</span>
          {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
        </div>
        
        {/* Change Indicator */}
        {change !== undefined && (
          <div className={`flex items-center space-x-1 mt-1 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={12} />
            <span className="text-xs font-medium">{Math.abs(change)}%</span>
            <span className="text-xs text-muted-foreground">vs last hour</span>
          </div>
        )}
      </div>
      {/* Threshold Warning */}
      {threshold && (
        <div className="mb-3 p-2 bg-muted rounded text-xs">
          <span className="text-muted-foreground">Threshold: {threshold}</span>
        </div>
      )}
      {/* Mini Trend Chart */}
      {trendData?.length > 0 && (
        <div className="h-12">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={trendData}>
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke={
                  status === 'critical' ? 'rgb(220, 38, 38)' :
                  status === 'warning' ? 'rgb(217, 119, 6)' :
                  status === 'good' ? 'rgb(5, 150, 105)' :
                  'rgb(59, 130, 246)'
                }
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default MetricCard;